<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/usage-rating/template" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditTemplateDefinition") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.TemplateName')"
              >
                <vs-input
                  :label="$t('setup.label.TemplateName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.templateDatas[0].templateName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6"
            >
              <vs-checkbox
                class="mt-5 mb-5 font-semibold"
                :value="isSelector"
                v-model="Reports.templateDatas[0].delimited"
                >{{ $t("setup.label.Delimiter") }}</vs-checkbox
              >
            </div>
            <div
              class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6"
            >
              <vs-checkbox
                class="mt-5 mb-5 font-semibold"
                :value="isSelector"
                v-model="Reports.templateDatas[0].isheader"
                >{{ $t("setup.label.IsHeader") }}</vs-checkbox
              >
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.ServiceCode") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ServiceCode')"
                >
                  <v-select
                    :label="'serviceCode'"
                    v-model="serviceData"
                    :options="planTemplateData.services"
                    :reduce="(obj) => obj.serviceCode"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    @input="productlist"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  >
                    <template v-slot:option="option">{{
                      option.serviceCode
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="min-w-200 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("setup.label.ProductCode")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('setup.label.ProductCode')"
                  >
                    <v-select
                      v-model="selectedProducts"
                      :options="availableproductsX"
                      :reduce="(obj) => obj.productCode"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :option-height="10"
                      class="min-w-200 w-full"
                      open-direction="bottom"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :show-labels="false"
                      label="productCode"
                      track-by="productCode"
                      :preselect-first="false"
                    >
                      <span
                        slot="selection"
                        slot-scope="{ values, search, isOpen }"
                        class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen"
                        :some="search"
                        >{{ values.length }} {{$t("setup.label.options_selected")}}</span
                      >
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                  <!-- <pre class="language-json"><code>{{ value  }}</code></pre> -->
                </div>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Delimiter')"
              >
                <vs-input
                  :label="$t('setup.label.Delimiter')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.templateDatas[0].delimiter"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.HeaderRecorderType')"
              >
                <vs-input
                  :label="$t('setup.label.HeaderRecorderType')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.templateDatas[0].headerecordtype"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|numeric"
                v-slot="{ errors }"
                :name="$t('setup.label.NumberOfFields')"
              >
                <vs-input
                  :label="$t('setup.label.NumberOfFields')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.templateDatas[0].numberOfFields"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>

            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-1 font-semibold"
                  >{{ $t("setup.label.EventRecordType") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.EventRecordType')"
                >
                  <v-select
                    label="chargeCode"
                    :options="output"
                    v-model="Reports.templateDatas[0].eventrecordtype"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mt-1 mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <h4>
                {{ $t("setup.label.CreateTemplateDefinition") }}
              </h4>
            </div>
          </div>
          <div class="vx-row mt-4">
            <div class="vx-col md-3">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.FieldType")
                }}</small>
                <v-select
                  label="regionName"
                  :options="FieldType"
                  v-model="Reports.fieldType"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <!-- <template v-slot:option="option">{{ option.item }}</template> -->
                </v-select>
              </div>
            </div>
            <div class="vx-col md-3">
              <vs-input
                :label="$t('setup.label.FieldName')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="Reports.fieldName"
              />
            </div>
            <div class="vx-col md-3">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.IdentifierType")
                }}</small>
                <v-select
                  label="regionName"
                  :options="Identifier"
                  v-model="Reports.identifierType"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <!-- <template v-slot:option="option">{{ option.item }}</template> -->
                </v-select>
              </div>
            </div>
            <div
              class="vx-col md-2"
            >
              <vs-input
                :label="$t('setup.label.Length')"
                class="w-full mb-2 font-semibold starlabel"
                :class="{ starlabel: Reports.templateDatas[0].delimited }"
                v-model="Reports.length"
                type="number"
              />
            </div>
            <div class="vx-col md-1 mt-4" style="margin: 0.5rem 0">
              <vs-button
                @click="addParameter"
                :disabled="
                  !Reports.length ||
                  !Reports.identifierType ||
                  !Reports.fieldName ||
                  !Reports.fieldName
                "
                icon-pack="feather"
                icon="icon-plus"
                :title="$t('setup.label.Add')"
                color="success"
                svgClasses="w-5 h-5
              hover:text-primary stroke-current cursor"
              >
              </vs-button>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <h4>
                {{ $t("setup.label.ExistsTemplateDefinition") }}
              </h4>
            </div>
          </div>
          <div class="vx-row mt-6">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="block overflow-x-auto">
                <table class="w-full">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.FieldType") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.FieldName") }}</b>
                    </td>

                    <td>
                      <b>{{ $t("setup.label.IdentifierType") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.Length") }}</b>
                    </td>
                    <td class="tHeadCenter">
                      <b>{{ $t("setup.label.Action") }}</b>
                    </td>
                  </tr>
                  <tr
                    v-for="(Reports, index) in Reports.templateDatas"
                    :key="index"
                  >
                    <td>{{ Reports.fieldType }}</td>
                    <td>{{ Reports.fieldName }}</td>
                    <td>{{ Reports.identifierType }}</td>
                    <td>{{ Reports.length }}</td>

                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <button
                          @click="removeItem(index)"
                          class="bGNone border-none view_editTable_btn"
                        >
                          <feather-icon
                            icon="TrashIcon"
                            :title="$t('setup.label.Delete')"
                            svgClasses="w-5 h-5 text-danger stroke-current cursor"
                            class="icon_row"
                          />
                        </button>
                      </div>
                    </vs-td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="editfeemaster"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const ReportsEmptyObj = {
  templateName: "",
  numberOfFields: "",
  isHeader: "",
  length: "",
  fieldName: "",
  identifierType: "",
  fieldType: "",
  headerRecordType: "",
  locale: "en",
  eventRecordType: "",
  delimited: "",
  delimiter: "",
  serviceCode: "",
  productCode: "",
  templateDatas: [],
};

export default {
  data() {
    return {
      Reports: ReportsEmptyObj,
      warningPopup: false,
      warningText: "",
      output: ["CDR", "SMS", "OTT"],
      isSelector: false,
      FieldType: [
        "Numeric",
        "VarChar",
        "TinyInt",
        "Decimal",
        "Text",
        "DateTime",
      ],
      Identifier: ["EventIdentifier", "ServiceIdentifier", "Default"],
      errorMessage: "",
      planTemplateData: {},
      availableproductsX: [],
      availableproducts: [],
      availableChannels: [],
      services: [],
      serviceData: "",
      selectedProducts: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      ReportsData: (state) => state.usageRating.TemplateData,
      planTemplate: (store) => store.planPrice.planTemplateData,
    }),
  },
  methods: {
    productlist() {},
    removeItem(i) {
      this.Reports.templateDatas.splice(i, 1);
    },
    addParameter() {
      try {
        let crateParameter = {
          fieldType: this.Reports.fieldType,

          identifierType: this.Reports.identifierType,

          fieldName: this.Reports.fieldName,
          length: this.Reports.length,
        };
        if (this.Reports.fieldType !== "") {
          this.Reports.templateDatas = [
            ...this.Reports.templateDatas,
            crateParameter,
          ];
          this.Reports.length = "";
          this.Reports.fieldName = "";
          this.Reports.identifierType = "";
          this.Reports.fieldType = "";
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getPlanTemplate() {
      try {
        await this.$store.dispatch("planPrice/setPlanTemplateData");
        this.planTemplateData = this.planTemplate;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editfeemaster() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        this.Reports.templateName = this.Reports.templateDatas[0].templateName;
        this.Reports.delimited = this.Reports.templateDatas[0].delimited;
        this.Reports.delimiter = this.Reports.templateDatas[0].delimiter;

        this.Reports.numberOfFields =
          this.Reports.templateDatas[0].numberOfFields;

        this.Reports.eventRecordType =
          this.Reports.templateDatas[0].eventrecordtype;
        this.Reports.headerRecordType =
          this.Reports.templateDatas[0].headerecordtype;
        this.Reports.isHeader = this.Reports.templateDatas[0].isheader;

        this.Reports.columns = this.Reports.templateDatas;
        this.Reports.serviceCode = this.serviceData;
        this.Reports.productCode = this.selectedProducts;

        delete this.Reports.templateDatas;
        delete this.Reports.fieldName;
        delete this.Reports.fieldType;
        delete this.Reports.identifierType;
        delete this.Reports.length;

        await this.$store.dispatch("usageRating/editTemplateAction", {
          id: this.id,
          data: this.Reports,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Template Edited Successfully!",
          type: "success",
        });
        this.$router.push("/setup/usage-rating/template");
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getfeemaster() {
      try {
        await this.$store.dispatch("usageRating/setTemplateById", this.id);
        this.Reports = this.ReportsData;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancel() {
      this.$router.push("/setup/usage-rating/template");
    },
  },
  watch: {
    Reports(val) {
      this.serviceData = val.templateDatas[0].serviceCode;
      this.selectedProducts = val.templateDatas[0].productCode;
    },
    serviceData(val) {
      if (val != null) {
        this.availableproductsX = [];
        this.serviceCode = val;
        for (let tempProduct of this.availableproducts) {
          if (tempProduct.serviceCode == this.serviceCode) {
            this.availableproductsX.push(tempProduct);
          }
        }
      } else {
        this.serviceCode = "";
      }
    },
    planTemplateData(val) {
      this.availableproducts = val.products;
      this.services = val.services;
    },
  },
  created() {},
  async mounted() {
    this.id = this.$route.params.id;
    await this.getfeemaster();
    await this.getPlanTemplate();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
